import React, { useState } from 'react';
import DateTimePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './dateTimePicker.scss';

const getISOFormattedDateWithTimeZone = (date: any) => (new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString());

export const DatePicker = ({
  defaultValue,
  classes,
  dataTestId,
  disabled,
  ref,
  onChange,
  dateFormat = 'dd-MM-yyyy',
  maxDate = '2049-12-31',
}: any) => {
  const defaultDate = defaultValue ? new Date(defaultValue) : null;
  const [date, setDate] = useState(defaultDate) as any;

  return (
    <div className="datepicker-wrapper" data-testid="custom-datepicker">
      <DateTimePicker
        dateFormat={dateFormat}
        selected={date}
        onChange={(value: any) => {
          const formattedDate = getISOFormattedDateWithTimeZone(value).split('T')[0];
          setDate(value);
          onChange(formattedDate);
        }}
        minDate={new Date()}
        maxDate={new Date(maxDate)}
        popperPlacement="bottom-end"
        className={`custom-datepicker ${classes || ''}`}
        data-testid={dataTestId}
        disabled={disabled}
        ref={ref}
      />
    </div>
  );
};

export const TimePicker = ({
  defaultValue,
  classes,
  dataTestId,
  disabled,
  ref,
  onChange,
  dateFormat = 'HH:mm',
  timeFormat = 'HH:mm',
}: any) => {
  const date = new Date();
  let hour: string;
  let minute: string;
  if (defaultValue) {
    hour = defaultValue.split(':')[0];
    minute = defaultValue.split(':')[1];
    date.setHours(parseInt(hour, 10), parseInt(minute, 10));
  }
  const [time, setTime] = useState(defaultValue ? date : null) as any;
  return (
    <div className="timepicker-wrapper" data-testid="custom-timepicker">
      <DateTimePicker
        selected={time}
        onChange={(value: any) => {
          const formattedTime = value?.toTimeString().split(':').slice(0, 2).join(':');
          setTime(value);
          onChange(formattedTime);
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={5}
        timeCaption="Time"
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        className={`custom-timepicker ${classes || ''}`}
        data-testid={dataTestId}
        disabled={disabled}
        ref={ref}
      />
    </div>
  );
};
